// Import react
import React, { useState } from "react";

// Import states, contexts, and CSS
import { useActiveUser } from "../../store/activeUserContext";

import { Form,  Button } from "react-bootstrap";
import {
  XCircle,
  Pencil,
  BackspaceReverse,
  CheckLg,
} from "react-bootstrap-icons";
import { InputGroup } from "react-bootstrap";

const MachineryListRow = ({ index, machinery, setUpdate , setFilter}) => {
  // Get user data from context
  const { activeUser } = useActiveUser();

  // Get variables from local storage
  const userId = activeUser._id;
  const token = localStorage.getItem("token");

  const { _id, machineryId, machineryType, machineryName } = machinery;

  const [editMachinery, setEditMachinery] = useState({

    machineryType: machineryType,
    machineryName: machineryName,
  });

  const [editMachineryBool, setEditMachineryBool] = useState(false);

  const handleDeleteMachinery = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_SERVER_URL}/api/machinery/${_id}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.ok) {
        console.log("Macchina eliminata correttamente");
      } else {
        console.error("Errore durante la eliminazione della macchina");
      }
    } catch (error) {
      console.error("Errore durante la richiesta DELETE:", error);
    }
  };

  const handleEditMachinery = async () => {
    setFilter("")
    try {
      const response = await fetch(
        `${process.env.REACT_APP_SERVER_URL}/api/machinery/users/${userId}/machinery/${_id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(editMachinery ),
        }
      );

      if (response.ok) {
        console.log("Macchina modificata correttamente");
      } else {
        console.error("Errore durante la modifica della macchina");
      }
    } catch (error) {
      console.error("Errore durante la richiesta PUT:", error);
    } finally {
      setEditMachineryBool(false)
      setUpdate((prevUpdate) =>!prevUpdate);

    }
  };

  const handleChangeEditBool = (e) => {
    setEditMachineryBool(!editMachineryBool);
    setEditMachinery({
      machineryType: editMachinery.machineryType,
      machineryName: editMachinery.machineryName,
    })
  };

  const handleChangeEdit = (e) => {
    setEditMachinery({...editMachinery, [e.target.name]: e.target.value });
  };

  return (
    <>
      <tr key={index}>
        <td>{machineryId}</td>

        {editMachineryBool ? (
          <>
          <td>
            {
              <InputGroup
              controlId="machineryType"
              className={"mb-2 d-flex align-items-center"}
              >
                <Form.Control
                  className="text-end"
                  type="text"
                  placeholder="Add new machinery type"
                  name="machineryType"
                  value={editMachinery.machineryType}
                  onChange={handleChangeEdit}
                  ></Form.Control>
              </InputGroup>
            }
          </td>
          <td>
            {
              <InputGroup
                controlId="machineryName"
                className={"mb-2 d-flex align-items-center"}
              >
                <Form.Control
                  className="text-end"
                  type="text"
                  placeholder="Add new machinery type"
                  name="machineryName"
                  value={editMachinery.machineryName}
                  onChange={handleChangeEdit}
                ></Form.Control>
              </InputGroup>
            }
          </td>
          <td>
          <Button variant="primary" size="sm"
          onClick={handleEditMachinery}
          >
            <CheckLg size={16} />
          </Button>
          <Button variant="danger" size="sm" onClick={handleChangeEditBool}>
            <BackspaceReverse size={16} />
          </Button>
        </td>



            </>
        ) : (
          <>
          
          <td>{machineryType}</td>
          <td>{machineryName}</td>
          <td>
          <Button
            variant="outline-primary"
            size="sm"
            onClick={handleChangeEditBool}
          >
            <Pencil size={16} />
          </Button>
          <Button variant="outline-danger" size="sm">
            <XCircle size={16} />
          </Button>
        </td>
          </>
        )}

      </tr>
    </>
  );
};

export default MachineryListRow;